import * as Swiper from "swiper/dist/js/swiper.js";

export default class initTreeKeySlider {
	constructor() {
		this.container = document.querySelector(".cp-tree-key-number");
		if (!this.container) return;

		this.slider = document.querySelector(".js-cp-tree-key-number");

		this.initSlider(this.slider);
	}
	initSlider(slider) {
		let isMobile;

        if(window.innerWidth <= 768){
			isMobile = true
        }else{
			isMobile = false
        }
		new Swiper(slider, {
			slidesPerView: isMobile ? 1 : 3,
			spaceBetween: isMobile ? 20 : 24,
			loop: false,
			pagination: {
				el: ".js-cp-tree-key-number-pagination",
				type: "bullets",
				bulletActiveClass: "-current",
				clickable: true
			},
			navigation: {
				nextEl: ".js-cp-tree-key-number-arrow-next",
				prevEl: ".js-cp-tree-key-number-arrow-prev"
			}
		});
	}
}
